import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Utils } from "../resources/utils";
import { AuthService } from "../services/authentication.service";
import { ShippingCost } from "../enums/shipping-cost.enum";
import { AmountsCargoEnum } from "../enums/amountsCargo.enum";
import { environment } from "src/environments/environment";
import { CompanyNamePipe } from "../pipe/companyName.pipe";
import { ModalEnum } from "../enums/modal.enum";
import { DialogComponent } from "src/app/shared/dialog/dialog.component";

@Injectable()
export class CompanyManager {
  private stateComanyOnlyDrive;



  constructor(
    public utils: Utils,
    public matDialog: MatDialog,
    private authService: AuthService,
  ) {

  }

  public getOnlyDriverByCompanyNit(nit) {

    let companies = this.authService && this.authService.getCompanies() ? this.authService.getCompanies() : null;
    this.stateComanyOnlyDrive = false;
    if (companies && companies.length) {
      const company = companies.filter((objet) => {
        return objet.companyId === nit;
      });
      if (company.length) {
        this.stateComanyOnlyDrive = !company[0].onlyDriverCanOperate;
        return this.stateComanyOnlyDrive;
      }
    }

    return true;
  }


  getUtilityByCompanyId(idCompany: string): number {
    let companies = this.authService && this.authService.getCompanies() ? this.authService.getCompanies() : null;
    if (companies && companies.length) {
      const company = companies.filter((objet) => {
        return objet.companyId === idCompany;
      });
      if (company[0] && this.utils.isDefined(company[0].utility) && company[0].utility) return company[0].utility
    }
    if (this.authService && this.authService.getCompanySaaS() && this.authService.getCompanySaaS().utility) return this.authService.getCompanySaaS().utility;
    return ShippingCost.MINIMUN_UTILITY
  }

  getutilityAdditionalServicesByCompanyId(idCompany: string): number {
    let companies = this.authService && this.authService.getCompanies() ? this.authService.getCompanies() : null;
    if (companies && companies.length) {
      const company = companies.filter((objet) => {
        return objet.companyId === idCompany;
      });
      if (company[0] && this.utils.isDefined(company[0].utilityAdditionalService) && company[0].utilityAdditionalService)
        return company[0].utilityAdditionalService
    }
    if (this.authService && this.authService.getCompanySaaS() && this.authService.getCompanySaaS().utilityAdditionalService)
      return this.authService.getCompanySaaS().utilityAdditionalService;
    if (this.authService && this.authService.getCompany() && this.authService.getCompany().companyId && this.authService.getCompany().companyId === environment.rootNit)
      return ShippingCost.MINIMUN_UTILITY_ADDITIONAL_COST_TECLOGI;
    return ShippingCost.MINIMUN_UTILITY_ADDITIONAL_COST;
  }

  getAdvancePercentageByCompanyId(idCompany): number {
    let companies = this.authService && this.authService.getCompanies() ? this.authService.getCompanies() : null;
    if (companies && companies.length) {
      const company = companies.filter((company) => {
        return company.companyId === idCompany;
      });
      if (company[0] && this.utils.isDefined(company[0].advancePercentage) && company[0].advancePercentage >= 0) return company[0].advancePercentage;
    }
    if (this.authService && this.authService.getCompany() && this.authService.getCompany().companyId && (this.authService.getCompany().companyId === environment.rootNit))
      return AmountsCargoEnum.MAX_ADVANCE_PERCENTAGE_ALLOWED_TECLOGI;
    if (this.authService && this.authService.getCompany() && this.authService.getCompany().advancePercentage) return this.authService.getCompany().advancePercentage;
    return AmountsCargoEnum.MAX_ADVANCE_PERCENTAGE_ALLOWED_ALL_COMPANIES;
  }

  getNameByCompanyId(idCompany: string): string {
    let companies = this.authService && this.authService.getCompanies() ? this.authService.getCompanies() : null;
    if (companies && companies.length) {
      const companyActive = companies.find((company) => company.companyId === idCompany);
      if (companyActive && companyActive.name) return companyActive.name;
    }
    return idCompany;
  }

  public async openDialogConfirm(title: string): Promise<{ confirm: boolean }> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: title,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const response = await this.matDialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
    return { confirm: response && response.state };
  }

  public async openDialogConfirmWithDescription(title: string, placeholder: string = 'Observaciones', maxLength: number = 200, minLength: number = 10): Promise<{ confirm: boolean, description: string }> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: title,
      inputText: true,
      placeholder: placeholder,
      maxLength: maxLength,
      minLength: minLength,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const response = await this.matDialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
    return { confirm: response && response.state, description: response && response.inputText ? response.inputText : '' };
  }


}
